<template>
  <b-modal
    v-model="visible"
    :title="form.id ? 'Xarajatni tahrirlash' : 'Yangi xarajat'"
    hide-footer
    centered
    size="md"
    modal-class="z-top-modal"
  >
    <div class="x-form">
      <div class="x-field">
        <label>Kategoriya <span class="text-danger">*</span></label>
        <select v-model="form.kassa_category_id" :class="{ 'invalid-border': errors.kassa_category_id }">
          <option :value="null" disabled>Kategoriya tanlang...</option>
          <option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.name }}</option>
        </select>
      </div>

      <div class="x-field">
        <label>To'lov turi <span class="text-danger">*</span></label>
        <select v-model="form.pay_type_id" :class="{ 'invalid-border': errors.pay_type_id }">
          <option :value="null" disabled>To'lov turi...</option>
          <option v-for="pay in paymentTypes" :key="pay.id" :value="pay.id">{{ pay.name }}</option>
        </select>
      </div>

      <div class="x-field">
        <label>Summa <span class="text-danger">*</span></label>
        <input
          type="number"
          v-model.number="form.amount"
          placeholder="0"
          :class="{ 'invalid-border': errors.amount }"
          @keyup.enter="save"
        >
      </div>

      <div class="x-field">
        <label>Izoh</label>
        <input
          type="text"
          v-model="form.comment"
          placeholder="Izoh..."
          @keyup.enter="save"
        >
      </div>

      <div class="x-actions">
        <button class="btn-cancel" @click="close">BEKOR</button>
        <button class="btn-save" :disabled="saving" @click="save">
          <span v-if="saving"><span class="spinner-border spinner-border-sm"></span> ...</span>
          <span v-else>SAQLASH</span>
        </button>
      </div>
    </div>
  </b-modal>
</template>

<script>
import axios from 'axios';

export default {
  name: 'XarajatForm',
  props: {
    value: { type: Boolean, default: false },
    categories: { type: Array, default: () => [] },
    paymentTypes: { type: Array, default: () => [] },
    dollarRate: { type: [Number, String], default: 1 },
    editItem: { type: Object, default: null },
  },
  data() {
    return {
      saving: false,
      errors: {},
      form: { id: null, kassa_category_id: null, pay_type_id: null, amount: null, comment: '' },
    };
  },
  computed: {
    visible: {
      get() { return this.value; },
      set(v) { this.$emit('input', v); }
    }
  },
  watch: {
    value(v) {
      if (v) this.resetFromProp();
    }
  },
  methods: {
    resetFromProp() {
      this.errors = {};
      if (this.editItem) {
        this.form = {
          id: this.editItem.id,
          kassa_category_id: this.editItem.kassa_category_id,
          pay_type_id: this.editItem.pay_type_id,
          amount: Number(this.editItem.dollar_summa) > 0 ? Number(this.editItem.dollar_summa) : Number(this.editItem.summa),
          comment: this.editItem.comment || '',
        };
      } else {
        this.form = { id: null, kassa_category_id: null, pay_type_id: null, amount: null, comment: '' };
      }
    },
    validate() {
      this.errors = {};
      if (!this.form.kassa_category_id) this.errors.kassa_category_id = true;
      if (!this.form.pay_type_id) this.errors.pay_type_id = true;
      if (!this.form.amount || this.form.amount <= 0) this.errors.amount = true;
      return Object.keys(this.errors).length === 0;
    },
    close() { this.visible = false; },
    async save() {
      if (!this.validate()) return;
      this.saving = true;
      const isDollar = Number(this.form.pay_type_id) === 3;
      const payload = {
        datetime: Math.floor(Date.now() / 1000),
        sklad_id: Number(localStorage.getItem('sklad_id')),
        user_id: Number(localStorage.getItem('user_id')),
        kassa_category_id: this.form.kassa_category_id,
        pay_type_id: this.form.pay_type_id,
        type: 'chiqim', // xarajat → kassadan chiqim (kassani kamaytiradi)
        summa: isDollar ? 0 : this.form.amount,
        dollar_summa: isDollar ? this.form.amount : 0,
        dollar_rate: this.dollarRate,
        comment: this.form.comment,
      };
      try {
        if (this.form.id) {
          await axios.patch(`/api/v1/kassa-order/id/${this.form.id}`, payload);
        } else {
          await axios.post('/api/v1/kassa-order', payload);
        }
        this.$emit('saved');
        this.close();
      } catch (e) {
        alert("Saqlashda xatolik: " + (e.response?.data?.message || e.message));
      } finally {
        this.saving = false;
      }
    }
  }
};
</script>

<style scoped>
.x-form { display: flex; flex-direction: column; gap: 14px; }
.x-field label { display: block; font-size: 13px; font-weight: 600; color: #475569; margin-bottom: 6px; }
.x-field input, .x-field select {
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  font-size: 14px;
  outline: none;
  transition: .15s;
  background: white;
}
.x-field input:focus, .x-field select:focus {
  border-color: #be185d;
  box-shadow: 0 0 0 3px rgba(190, 24, 93, .1);
}
.invalid-border { border-color: #ef4444 !important; }
.x-actions { display: flex; justify-content: flex-end; gap: 10px; margin-top: 6px; }
.btn-cancel, .btn-save {
  border: none;
  padding: 10px 22px;
  border-radius: 10px;
  font-weight: 700;
  cursor: pointer;
  transition: .15s;
  font-size: 13px;
}
.btn-cancel { background: #f1f5f9; color: #475569; }
.btn-cancel:hover { background: #e2e8f0; }
.btn-save { background: linear-gradient(135deg, #be185d, #db2777); color: white; box-shadow: 0 4px 12px rgba(190,24,93,.3); }
.btn-save:disabled { opacity: .6; cursor: not-allowed; }
</style>
